module.exports = __webpack_public_path__ + "static/media/bookmark3.bbb87e5c.png";